import React from 'react';
import {loadGoogleMaps} from '../../helper/googleMaps';

// Renders its children only once the Google Maps API is available.
// Children such as PlacesAutocomplete throw if `window.google` is missing.
export default class GoogleMapsGate extends React.Component {
    state = {ready: false, failed: false};

    componentDidMount() {
        this._mounted = true;
        loadGoogleMaps()
            .then(() => this._mounted && this.setState({ready: true}))
            .catch(() => this._mounted && this.setState({failed: true}));
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    render() {
        if (this.state.ready) return this.props.children;
        // `errorFallback` is shown if the Maps script is blocked or fails to load, so the UI never stays disabled.
        if (this.state.failed) return this.props.errorFallback || this.props.fallback || null;
        return this.props.fallback || null;
    }
}
